import React from 'react';
import MenuItem from 'app/shared/layout/menus/menu-item';
import { DropdownItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Translate, translate } from 'react-jhipster';
import { NavLink as Link } from 'react-router-dom';
import { NavDropdown } from './menu-components';

export const EntitiesMenu = props => (
  <NavDropdown
    icon="th-list"
    name={translate('global.menu.entities.main')}
    id="entity-menu"
    style={{ maxHeight: '80vh', overflow: 'auto' }}
  >
    {props.isAdmin &&
    <MenuItem icon="asterisk" to="/provider">
      <Translate contentKey="global.menu.entities.provider" />
    </MenuItem>}
    <MenuItem icon="asterisk" to="/asset-use">
      <Translate contentKey="global.menu.entities.assetUse" />
    </MenuItem>
    <MenuItem icon="asterisk" to="/asset">
      <Translate contentKey="global.menu.entities.asset" />
    </MenuItem>
    {/* jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here */}
  </NavDropdown>
);
